
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTrackOffPort as ObiTrackOffPortElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-track-off-port.js';
 
 
 

 
 export const ObiTrackOffPort = createComponent({
   react: React,
   tagName: 'obi-track-off-port',
   elementClass: ObiTrackOffPortElement,
   events: {
     
   }
  });
 
 